import React from 'react';

import { holdingBox } from '@/styles';

const Search = () => <div css={holdingBox}>Search</div>;

export default Search;
